import React from 'react';

function Header() {
	return <header className="text-center">Password Generator</header>;
}

export default Header;
